<template>
  <gj-popover
      v-model="visible"
      placement="bottom"
      width="400"
      trigger="manual">
    <template slot="reference">
      <el-row
          type="flex"
          align="middle"
          :class="{'edit-content': fixedIcon}"
          :style="{'justify-content': align === 'right' ? 'flex-end' : ''}">
        <slot>
          <gj-tooltip v-if="showPrefix" :content="value" :text-line="1"><span style="color: #999999;">{{prefixText}}</span>{{value}}</gj-tooltip>
          <span v-else  class="over-flow" >{{value}}</span>
        </slot>
        <div  :class="{'gj-cell-display-switch': tableCellEdit,'edit-icon':!showPrefix}" @click="memoEdit()">
          <i class="el-icon-edit pen-icon"></i>
        </div>
      </el-row>
    </template>
    <template v-if="type === 'textarea'">
       <div style="display: inline-block;font-weight: 600;padding-bottom: 12px;font-size: 13px; color: #333;">
         <span>{{popTitle}}</span>
       </div>
      <gj-textarea
          v-model="dataValue"
          maxlength="500"
          placeholder="最多输入500个字"
          :show-word-limit="true"
          :styles="{height: height}">
      </gj-textarea>
    </template>
    <template v-else-if="type === 'date'">
      <gj-date-picker
          v-model="dataValue"
          v-bind="editConfig"
          width="1"
      ></gj-date-picker>
    </template>
    <div style="text-align: right;margin-top: 12px">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button
          :size="'mini'"
          type="primary"
          :disabled="confirmDisabled"
          @click="confirm()"
          :loading="loading"
      >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
export default {
  name: "gj-edit-input",
  props: {
    value: null,
    onConfirm: {
      type: Function
    },
    item: {
      type: Object
    },
    type: {
      type: String,
      default: 'textarea',
      validator: function (value) {
        return ['textarea', 'date'].indexOf(value) !== -1
      }
    },
    editConfig: {
      default: () => {}
    },
    popTitle: {
      type: String
    },
    tableCellEdit: {
      type: Boolean,
      default: false
    },
    fixedIcon: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left'
    },
    validator: {
      type: Function,
      default: () => true
    },
    height: {
      type: String,
      default: '80px'
    },
    prefixText:{
      type:String,
      default:'',
    },
    showPrefix:{
      default:true,
      type:Boolean
    }
  },
  watch: {
    value: {
      handler(value) {
        this.dataValue = value;
      },
      immediate: true
    }
  },
  data() {
    return {
      dataValue: null,
      visible: false,
      loading: false
    }
  },
  created() {
    this.dataValue = this.value;
  },
  computed: {
    confirmDisabled() {
      return !this.validator(this.dataValue);
    }
  },
  methods: {
    memoEdit() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.dataValue = this.value;
    },
    confirm() {
      this.loading = true;
      this.onConfirm(this.dataValue, this.item, () => {
        this.visible = false;
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.edit-content {
  padding-right: 15px;
  position: relative;
  .edit-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
}
.pen-icon {
  cursor: pointer;
  margin-left: 5px;
  font-size: 13px;
}
 .over-flow {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
